import { Button, Icons } from "construct-ui";
import ViewBase from "../../view-base.view";
import 'CssFolder/schedule/jpo/jpo-calendar.scss';
import moment from "moment";
import { formats as FORMATS } from '../../../config/constants';
import jpoScheduleModel from "../../../models/schedule/jpo-schedule.model";

export default function JPOScheduleCalendarWeekView() {
    ViewBase.call(this);
    let schedules = {};
    let summaries = {};
    let userId;
    let lblWeek = '';
    let headerRow = {};
    let fromDate;
    let toDate;

    const getScheduleRoute = () => {
        this.showLoading();
        jpoScheduleModel.getScheduleRoute(
            (result) => {
                massageData(result.data);
                this.hideLoading();
            },
            (error) => {
                this.hideLoading();
                this.handleError(error);
            },
            {
                userId: userId,
                fromDate: fromDate.format(FORMATS.apiDateFormat),
                toDate: toDate.format(FORMATS.apiDateFormat),
                pageIndex: 1,
                pageSize: 300
            })

    }
    const massageData = (data) => {
        schedules = {};
        Object.keys(headerRow).forEach(u => {
            schedules[u] = data.filter(s => s.scheduleDate == u).map((s) => {
                return {
                    siteName: s.siteName,
                    startTime: s.startTime,
                    endTime: s.endTime,
                    planDwellTime:s.planDwellTime,
                    planTravelingTime:s.planTravelingTime,
                    sequence:s.sequence
                }
            });
            //summaries[u]= schedules[u].reduce((s, d) => s +  (d.planDwellTime * 60) + (d.sequence==1? 0:d.planTravelingTime), 0)
            summaries[u]= schedules[u].reduce((s, d) => s +  (d.planDwellTime * 60) + d.planTravelingTime, 0)
        });

        
    }
    const setWeek = (selDate) => {
        fromDate = selDate.clone().startOf('W');
        toDate = selDate.clone().endOf('week');
        lblWeek = `${fromDate.format(FORMATS.dateFormat)} ~ ${toDate.format(FORMATS.dateFormat)} (${selDate.week()}W)`;

        let d = fromDate.clone();
        headerRow = [];
        for (let i = 0; i < 7; i++) {
            let d1 = d.clone().add(i, 'd');
            headerRow[d1.format(FORMATS.apiDateFormat)] = `${d1.format(FORMATS.dateFormat)}(${d1.format('ddd')})`;
        }

        getScheduleRoute();
    }
    const onPreClick = () => {
        fromDate = fromDate.add(-1, 'd');
        setWeek(fromDate);
    }
    const onNextClick = () => {
        toDate = toDate.add(1, 'd');
        setWeek(toDate);
    }

    return {
        oninit: ({ attrs }) => {
            userId = attrs.userId;
            setWeek(moment(attrs.scheduleDate, FORMATS.apiDateFormat));
        },
        oncreate: function (vnode) {

        },
        view: (vnode) => {
            return [
                m('.week-ctr', [
                    m('.week-range', [
                        m(Button, {
                            iconLeft: Icons.CHEVRON_LEFT,
                            intent: 'primary',
                            size: 'xs',
                            onclick: onPreClick
                        }),
                        m('.week-lbl', lblWeek),
                        m(Button, {
                            iconLeft: Icons.CHEVRON_RIGHT,
                            intent: 'primary',
                            size: 'xs',
                            onclick: onNextClick
                        })
                    ]),
                    m('table', { style: "width:100%;table-layout: fixed;" }, [
                        m('tr', Object.keys(headerRow).map(k => m('th', headerRow[k]))
                        ),
                        m('tr', Object.keys(headerRow).map(k => m('td',{style:"vertical-align: top;padding: 10px;"},
                            m('div',{style:"position:relative;min-height: 30px;"}, schedules[k]?.map(s => m('.w-item',[
                                m('.w-item-title',s.siteName),
                                m('.w-item-time',`${s.startTime} ~ ${s.endTime}`)
                            ]
                                
                            )))
                        ))),
                        m('tr', Object.keys(headerRow).map(k =>  m('td', m('div',
                            ((summaries[k] || 0)==0) ? this.getText("LT00001312", 'Unscheduled'): `${schedules[k]?.length} Store(s) -${(summaries[k] / 3600) >= 1 ? `${parseInt(summaries[k] / 3600)} hour` : ''} ${parseInt((summaries[k] % 3600) / 60)} min`)
                        )))
                        
                    ])
                ]),
                this.getBaseViews()
            ]
        
        }
    }
}